<template>
  <div class="HomePanel">

    <HeaderSection
      title="Welkom op Energieke Verhalen">
      <p>
        Op dit platform presenteren we interessante en leerzame verhalen die gaan over de energietransitie in woningen binnen provincie Utrecht.
      </p>

      <Link 
        class="Link__more" 
        arrow 
        label="Meer over Energieke Verhalen" 
        :to="{ name: 'page-about' }" />
    </HeaderSection>

    <ContentSection 
      grow
      class="ContentSection--home">
      <p>
        Met wat voor verhalen kunnen we je inspireren?
      </p>
      <Menu 
        :horizontal="false"
        arrow
        :items="primaire_links"
      />
      <SectionHeader label="Gericht zoeken" />
      <Menu 
        :horizontal="false"
        arrow
        :items="secundaire_links"
      />
    </ContentSection>

    <ContentSection>
      <ContentTip>
        <p>
          Heb je ook een interessant, leerzaam en / of bijzonder verhaal dat hier niet mag ontbreken?
        </p>
        <Link 
          arrow 
          label="Laat het ons weten!" 
          :to="{ name: 'page-aanmaken' }" />
      </ContentTip>
    </ContentSection>

  </div>
</template>

<script>

import Link from '@/components/Link';
import Menu from '@/components/Menu';
import SectionHeader from '@/components/section/Header'; 
import HeaderSection from '@/components/section/HeaderSection';
import ContentSection from '@/components/section/ContentSection';
import ContentTip from '@/components/content/Tip';

export default { 
  name: 'home',
  components: {
    Link,
    Menu,
    SectionHeader,
    HeaderSection,
    ContentSection,
    ContentTip
  },
  data() {
    return {
      primaire_links: [
        {
          label: 'Verhalen',
          to: { name: 'list-projecten' }
        },
        {
          label: 'Thema\'s',
          to: { name: 'list-themas' }
        }
      ],
      secundaire_links : [
        {
          label: 'Per gemeente',
          to: { name: 'list-gemeenten' }
        },
        {
          label: 'Per wijk',
          to: { name: 'list-wijken' }
        },
        {
          label: 'Per betrokken partij',
          to: { name: 'list-partijen' }
        },
        // {
        //   label: 'Platforms & Samenkomst Plaatsen',
        //   to: { name: 'list-platforms' }
        // }
      ]
    }
  }
}
</script>

<style lang="scss">
  .HomePanel {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 24px;

    .ContentSection--home {
      padding: 32px 32px 32px;

      p {
        margin: 0;
        font-family: $font_body;
        font-size: 16px;
      }
      .Menu {
        margin-top: 8px;
        font-weight: bold;
        font-size: 16px;
        line-height: 32px;
        letter-spacing: -0.01px;
        margin-bottom: 48px;
      }
    }
  }

</style>
